import React from 'react';
import { Box, Typography } from '@mui/material';
import PixData from './PixData';

// Pix Automático uses the same QR Code of a regular Pix, but the payer also authorizes
// the next charges on the bank app. Some banks show that authorization on a separate
// screen, so we make that step explicit.
export default function AutomaticPixData({ title, text, disclaimer, invoice, children, maxWidth = 'sm' }) {
    return (
        <PixData
            maxWidth={maxWidth}
            title={title}
            text={text}
            disclaimer={disclaimer}
            invoice={invoice}
            instructions={
                <Box component="ol" sx={{ m: 0, pl: 2.5, '& li': { mb: 1 } }}>
                    <Typography component="li" variant="body2">
                        Abra o app do seu banco e escaneie o QR Code ao lado, ou use o "Pix Copia e Cola".
                    </Typography>
                    <Typography component="li" variant="body2">
                        Confirme o pagamento da primeira cobrança.
                    </Typography>
                    <Typography component="li" variant="body2">
                        <b>Autorize o Pix Automático.</b> Em alguns bancos essa autorização aparece em uma tela separada, logo após o pagamento. Não pule essa etapa!
                    </Typography>
                </Box>
            }
        >
            {children}
        </PixData>
    );
}
